import { CameraIcon, ClockIcon, CoffeeIcon, CreditCardIcon, DropIcon, InfoIcon, ShieldCheckIcon, SparkleIcon, StarIcon, type IconProps } from '@phosphor-icons/react';
import type { ComponentType } from 'react';

const ICONS: Record<string, ComponentType<IconProps>> = {
  clock: ClockIcon,
  shield: ShieldCheckIcon,
  card: CreditCardIcon,
  camera: CameraIcon,
  coffee: CoffeeIcon,
  star: StarIcon,
  sparkle: SparkleIcon,
  drop: DropIcon,
  info: InfoIcon,
};

export function CardIcon({ name, ...props }: { name: string } & IconProps) {
  const C = ICONS[name] ?? InfoIcon;
  return <C weight="duotone" color="var(--color-icon-accent)" aria-hidden {...props} />;
}

export const CARD_ICON_NAMES = Object.keys(ICONS);
